/// Ошибка аутентификации
export const CODE_ERR_AUTH_ERROR = 1;

// Детально ошибки аутентификации:

/// Вышел срок годности токена
export const CODE_AUTH_TOKEN_EXPIRED = 2;    // CODE_ERR_AUTH_ERROR + 1

/// Токен не прошел проверку
export const CODE_AUTH_TOKEN_INVALID = 3;

/// Токен отсутствует в запросе
export const CODE_AUTH_TOKEN_MISSING = 4;

/// Не удалось разпарсить токен, мусор какой то
export const CODE_AUTH_TOKEN_PARSING = 5;

/// Не удалось создать токен
export const CODE_AUTH_TOKEN_CREATE = 6;

/// Клиент не прислал строку типа userAgent
export const CODE_AUTH_SYSTEM_UNKNOWN = 7;

/// Неизвестен IP
export const CODE_AUTH_NO_IP_ADDRESS = 8;

/// Пользователь не прошел проверку по мылу и тд.
export const CODE_AUTH_UNVERIFIED = 9;

/// Отключен/забанен и тп, отдельный пользователь или клиент целиком
export const CODE_AUTH_SUSPENDED = 10;

/// Пользователь не имеет назначенных ролей
//const CODE_AUTH_HAS_NO_ROLES = 11;

/// Такой сессии нет в базе
//const CODE_AUTH_SESSION_NOT_FOUND = 12;
//static MSG_AUTH_SESSION_NOT_FOUND: &str = "Session not found or was closed before.";

/// Закончился срок действия сессии
export const CODE_AUTH_SESSION_EXPIRED = 13;

/// Сессия была закрыта
export const CODE_AUTH_SESSION_CLOSED = 14;

/// Ошибка доступа к БД во время аутентификации
//const CODE_AUTH_DATABASE_ERROR = 15;

/// Роли пользователя не позволяют получить доступ к рессурсу
//const CODE_AUTH_NOT_PERMITTED = 16;


//const CODE_ERR_ACCOUNT_ERROR = 30;

export const CODE_ACC_USER_NOT_FOUND = 31;      // CODE_ERR_ACCOUNT_ERROR + 1

export const CODE_ACC_ALREADY_EXISTS = 32;

export const CODE_ACC_ALREADY_VERIFIED = 33;

export const CODE_ACC_ATTEMPTS_EXCEEDED = 34;

export const CODE_ACC_INVALID_CODE = 35;

export const CODE_ACC_USER_HAS_NO_EMAIL = 36;

export const CODE_ACC_TO_FAST = 37;

export const CODE_ACC_EXPIRED = 38;

export const CODE_ACC_EMAIL_ALREADY_USED = 39;

export const CODE_ACC_VERIFIED_EMAIL_DELETE = 40;


export const CODE_ERR_DATABASE = 300;

export const CODE_BAD_REQUEST = 400;

export const CODE_UNAUTHORIZED = 401;

export const CODE_ERR_NOT_FOUND = 404;

export const CODE_ERR_INTERNAL_SERVER = 500;